module.exports = __webpack_public_path__ + "static/media/Dell XPS 13\".fb4b5c72.png";